module Meevo.Components.Controls.SmartMover {
    import Service = Model.Service;


    export class ServicesCollection extends SmartMoverApiCollection<Service> implements IApiCollection<Service> {

        get url() {
            return 'Service';
        }

        constructor(connectedModel: ModelValueType[], items: Service[] = [], options: ICollectionOptions<Service> = {}) {
            super(connectedModel, items, options);
        }
    }

}